(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["access-layer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ft-access-layer')) {
    customElements.define('ft-access-layer', class extends HTMLElement {
      connectedCallback() {
        if (this.dialog || !window.HTMLDialogElement?.prototype.showModal) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.fallback = this.querySelector('details.acquisition');
        this.trigger = this.querySelector('[data-access-open]');
        const body = this.querySelector('.acquisition__body');
        const wasOpen = this.fallback.open;
        this.dialog = document.createElement('dialog');
        this.dialog.className = 'access-layer';
        this.dialog.id = this.dataset.dialogId;
        this.dialog.setAttribute('aria-labelledby', body.querySelector('[data-success-title]')?.id || this.dataset.dialogId + '-title');
        this.dialog.append(body);
        this.append(this.dialog);
        this.fallback.open = false;
        this.fallback.hidden = true;
        this.trigger.hidden = false;
        this.trigger.setAttribute('aria-haspopup', 'dialog');
        this.trigger.setAttribute('aria-controls', this.dialog.id);
        this.trigger.setAttribute('aria-expanded', 'false');
        this.querySelector('[data-access-close]').hidden = false;
        this.trigger.addEventListener('click', () => this.open(), options);
        this.querySelector('[data-access-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('close', () => {
          this.trigger.setAttribute('aria-expanded', 'false');
          this.trigger.focus({ preventScroll: true });
        }, options);
        this.dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const focusable = [...this.dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),iframe,summary,[tabindex="0"]')].filter(el => el.getClientRects().length && !el.closest('[hidden]'));
          const first = focusable[0], last = focusable.at(-1);
          if (!first) { event.preventDefault(); return; }
          if (event.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && (document.activeElement === last || !focusable.includes(document.activeElement))) { event.preventDefault(); first.focus(); }
        }, options);
        const updateViewport = () => {
          if (!this.dialog.open) return;
          const viewport = window.visualViewport;
          this.dialog.style.setProperty('--access-height', (viewport?.height || innerHeight) + 'px');
          this.dialog.style.setProperty('--access-top', (viewport?.offsetTop || 0) + 'px');
          this.dialog.toggleAttribute('data-compact', (viewport?.height || innerHeight) < 620);
          if (this.dialog.contains(document.activeElement) && document.activeElement.matches('input')) requestAnimationFrame(() => document.activeElement.scrollIntoView({ block: 'nearest' }));
        };
        this.updateViewport = updateViewport;
        window.visualViewport?.addEventListener('resize', updateViewport, options);
        window.visualViewport?.addEventListener('scroll', updateViewport, options);
        window.addEventListener('resize', updateViewport, options);
        this.dialog.addEventListener('shopify:block:select', () => this.open(), options);
        const form = this.dialog.querySelector('form.signup-form:not([data-klaviyo-form])');
        if (form) {
          form.noValidate = true;
          form.addEventListener('submit', event => {
            const email = form.querySelector('input[type=email]');
            const consent = form.querySelector('input[type=checkbox][required]');
            const invalid = email && !email.validity.valid ? email : consent && !consent.checked ? consent : null;
            if (!invalid) return;
            event.preventDefault();
            event.stopPropagation();
            const message = form.querySelector('[data-client-error]');
            message.textContent = invalid === email ? this.dataset.emailError : this.dataset.consentError;
            message.hidden = false;
            invalid.setAttribute('aria-invalid', 'true');
            invalid.setAttribute('aria-describedby', [...new Set(((invalid.getAttribute('aria-describedby') || '') + ' ' + message.id).trim().split(/\s+/))].join(' '));
            invalid.focus({ preventScroll: true });
            invalid.scrollIntoView({ block: 'nearest' });
          }, options);
          form.addEventListener('input', event => {
            if (!event.target.matches('input')) return;
            if (event.target.validity.valid) {
              event.target.removeAttribute('aria-invalid');
              const message = form.querySelector('[data-client-error]');
              const descriptions = (event.target.getAttribute('aria-describedby') || '').split(' ').filter(id => id !== message.id);
              if (descriptions.length) event.target.setAttribute('aria-describedby', descriptions.join(' ')); else event.target.removeAttribute('aria-describedby');
              message.hidden = true;
            }
          }, options);
        }
        if (wasOpen) this.open();
      }
      open() {
        if (this.dialog.open) return;
        this.dialog.showModal();
        this.updateViewport();
        this.trigger.setAttribute('aria-expanded', 'true');
        const result = this.dialog.querySelector('[data-form-result]');
        (result || this.dialog.querySelector('.acquisition__heading')).focus({ preventScroll: true });
      }
      disconnectedCallback() { this.abort?.abort(); if (this.dialog?.open) this.dialog.close(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["campaign-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ft-campaign-media')) {
    customElements.define('ft-campaign-media', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.mobile = matchMedia('(max-width: 749px)');
        this.visible = this.hasAttribute('data-eager');
        const options = { signal: this.abort.signal };
        this.mobile.addEventListener('change', () => this.configure(), options);
        document.addEventListener('visibilitychange', () => this.playback(), options);
        window.addEventListener('pageshow', () => this.playback(), options);
        // A browser may require a genuine gesture (for example in Low Power Mode).
        // Retry synchronously inside that gesture, without adding a playback control.
        ['touchend', 'click', 'keydown'].forEach(type => document.addEventListener(type, () => this.playback(), options));
        this.observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; this.configure(); });
        this.observer.observe(this);
        this.configure();
      }
      configure() {
        const template = this.mobile.matches ? this.querySelector('template[data-mobile]') || this.querySelector('template[data-desktop]') : this.querySelector('template[data-desktop]') || this.querySelector('template[data-mobile]');
        if (this.template !== template) { this.removeVideo(); this.template = template; }
        if (!this.video && this.visible && template) {
          this.video = template.content.querySelector('video').cloneNode(true);
          const active = this.video;
          // Set both content attributes and DOM properties before inserting into WebKit.
          active.defaultMuted = active.muted = true;
          active.autoplay = active.playsInline = active.loop = true;
          active.controls = false;
          active.disablePictureInPicture = true;
          ['autoplay', 'muted', 'playsinline', 'webkit-playsinline', 'loop'].forEach(name => active.setAttribute(name, ''));
          active.removeAttribute('controls');
          active.setAttribute('aria-hidden', 'true');
          active.setAttribute('tabindex', '-1');
          active.addEventListener('playing', () => { active.classList.remove('is-fallback'); active.classList.add('is-playing'); });
          active.addEventListener('error', () => this.fallback(active), true);
          active.addEventListener('pause', () => this.fallback(active));
          active.addEventListener('canplay', () => this.playback());
          this.append(active);
        }
        this.playback();
      }
      playback() {
        if (!this.video || this.video.error) { return; }
        if (!this.visible || document.hidden) { this.video.pause(); return; }
        const active = this.video;
        if (!active.paused || this.pending === active) { return; }
        // Do not hide the element while requesting playback: iOS checks visibility.
        active.classList.remove('is-fallback');
        this.pending = active;
        active.play().catch(() => { this.fallback(active); }).finally(() => { if (this.pending === active) this.pending = null; });
      }
      fallback(active) {
        if (this.video !== active) return;
        active.classList.remove('is-playing');
        active.classList.add('is-fallback');
      }
      removeVideo() {
        if (this.video) { this.video.pause(); this.video.removeAttribute('src'); this.video.querySelectorAll('source').forEach(source => source.remove()); this.video.load(); this.video.remove(); this.video = null; }
        this.template = null;
        this.pending = null;
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.removeVideo(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["campaign-viewport"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ftCampaignViewport) return;
    window.ftCampaignViewport = true;
    const root = document.documentElement;
    const mobile = matchMedia('(max-width:749px), (max-width:1024px) and (pointer:coarse)');
    let frame;
    function update() {
      frame = null;
      if (!mobile.matches) {
        root.style.removeProperty('--ft-campaign-height');
        root.style.removeProperty('--ft-campaign-screen-height');
        return;
      }
      const viewport = window.visualViewport;
      // Pinch zoom and form keyboards must not recompose the campaign behind a dialog.
      if (viewport && Math.abs(viewport.scale - 1) > .01) return;
      if (document.activeElement?.matches('input,textarea,select,[contenteditable="true"]')) return;
      const visibleHeight = Math.round(viewport?.height || window.innerHeight);
      const height = Math.max(visibleHeight, window.innerHeight);
      root.style.setProperty('--ft-campaign-height', `${height}px`);
      // Mobile Safari can report a viewport shorter than the display even with
      // viewport-fit=cover. Extend the film, not the independently anchored UI.
      const touchDisplay = matchMedia('(pointer:coarse)').matches;
      const sides = [window.screen.width, window.screen.height];
      const displayHeight = touchDisplay && Math.min(...sides) > 0
        ? (matchMedia('(orientation:landscape)').matches ? Math.min(...sides) : Math.max(...sides))
        : 0;
      root.style.setProperty('--ft-campaign-screen-height', `${displayHeight}px`);
    }
    function schedule() { if (frame == null) frame = requestAnimationFrame(update); }
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('focusout', schedule);
    document.addEventListener('shopify:section:load', schedule);
    mobile.addEventListener('change', schedule);
    update();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["catalogue-search"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ft-catalogue-search'))customElements.define('ft-catalogue-search',class extends HTMLElement{
    connectedCallback(){
      this.events=new AbortController();const options={signal:this.events.signal};
      this.input=this.querySelector('[name=q]');this.grid=this.querySelector('.commerce-grid');
      this.disclosure=this.querySelector('.catalogue-search__disclosure');
      this.summary=this.disclosure.querySelector('summary');
      this.form=this.querySelector('form');
      this.summary.addEventListener('click',event=>{event.preventDefault();this.setExpanded(!(this.expanded??this.disclosure.open));},options);
      this.status=this.querySelector('[role=status]');this.clear=this.querySelector('[type=reset]');
      this.pagination=this.querySelector('.commerce-pagination');
      this.original=[...(this.grid?.children||[])];this.cards=new Map();this.index(this.original);
      this.loaded=new Set([Number(this.dataset.currentPage)||1]);
      this.input.addEventListener('input',()=>{this.filter();if(this.input.value.trim())this.loadPages();},options);
      this.querySelector('form').addEventListener('submit',event=>{event.preventDefault();this.filter();this.loadPages();},options);
      this.querySelector('form').addEventListener('reset',()=>{this.input.value='';this.filter();this.input.focus();},options);
      this.disclosure.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();this.setExpanded(false);}},options);
      const focusSearch=()=>{if(location.hash==='#ShopSearch')this.setExpanded(true);};
      window.addEventListener('hashchange',focusSearch,options);focusSearch();
    }
    disconnectedCallback(){this.events?.abort();this.request?.abort();this.expansion?.cancel();clearTimeout(this.announcement)}
    setExpanded(open){
      const current=this.expansion?getComputedStyle(this.form):null;
      const from=current?{opacity:current.opacity,transform:current.transform,clipPath:current.clipPath}:null;
      this.expansion?.cancel();this.expansion=null;this.expanded=open;
      this.disclosure.open=true;this.form.inert=!open;
      if(!open&&this.form.contains(document.activeElement))this.summary.focus({preventScroll:true});
      const finish=()=>{this.disclosure.open=open;this.expansion=null;};
      if(matchMedia('(prefers-reduced-motion: reduce)').matches||!this.form.animate){finish();return;}
      const closed={opacity:0,transform:'translateY(-8px)',clipPath:'inset(0 0 100% 0)'};
      const opened={opacity:1,transform:'translateY(0)',clipPath:'inset(0 0 0% 0)'};
      const animation=this.form.animate([from||(open?closed:opened),open?opened:closed],{duration:open?300:200,easing:'cubic-bezier(0.16,1,0.3,1)'});
      this.expansion=animation;
      animation.onfinish=()=>{if(this.expansion===animation)finish();};
    }
    normalize(value){return value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase().trim()}
    index(cards){for(const card of cards){const link=card.querySelector('h2 a');if(link)this.cards.set(link.getAttribute('href'),{node:card,title:this.normalize(link.textContent),available:card.dataset.productAvailable==='true'});}}
    filter(){
      const query=this.normalize(this.input.value);this.clear.hidden=!query;
      if(this.pagination)this.pagination.hidden=!!query;
      const archive=this.querySelector('.collection-archive');if(archive)archive.hidden=!!query;
      const matches=query?[...this.cards.values()].filter(card=>card.available&&card.title.includes(query)).map(card=>card.node):this.original;
      if(this.grid){this.grid.replaceChildren(...matches);this.grid.classList.toggle('commerce-grid--single',matches.length===1);this.grid.classList.toggle('commerce-grid--pair',matches.length===2);}
      clearTimeout(this.announcement);
      this.status.textContent=!query?'':this.failed?this.status.dataset.error:this.loading?this.status.dataset.loading:matches.length?this.status.dataset.count.replace('[count]',matches.length):this.status.dataset.empty;
    }
    async loadPages(){
      if(this.loading)return;
      const total=Number(this.dataset.pages)||1;if(this.loaded.size>=total)return;
      this.loading=true;this.failed=false;this.filter();this.request=new AbortController();
      try{
        for(let page=1;page<=total;page++){
          if(this.loaded.has(page))continue;
          const url=new URL(location.href);url.hash='';url.searchParams.set('section_id',this.dataset.section);url.searchParams.set(this.dataset.pageParam||'page',page);
          const response=await fetch(url,{signal:this.request.signal});if(!response.ok)throw new Error('Catalogue load failed');
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          const grid=doc.querySelector('ft-catalogue-search .commerce-grid');if(!grid)throw new Error('Missing catalogue');
          grid.querySelectorAll('script').forEach(script=>script.remove());this.index([...grid.children]);this.loaded.add(page);this.filter();
        }
      }catch(error){if(error.name!=='AbortError')this.failed=true;}
      finally{this.loading=false;if(this.isConnected)this.filter();}
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["commerce-header"] && !Shopify.designMode) return;
  try {
    function setupCommerceNavigation(){
 const header=document.querySelector('.commerce-header'),menu=header?.querySelector('.commerce-menu');if(!menu||menu.dataset.ready)return;menu.dataset.ready='true';
 menu.querySelector('a[href$="#ShopSearch"]')?.addEventListener('click',()=>{menu.open=false;setTimeout(()=>{const field=document.querySelector('#ShopSearch');if(field){const search=field.closest('ft-catalogue-search');if(search?.setExpanded)search.setExpanded(true);else{field.closest('details').open=true;field.focus();}}},0);});
 const campaign=document.querySelector('.commerce-campaign');const campaignMark=campaign?.querySelector('.commerce-campaign__brand');if(campaignMark)new IntersectionObserver(([entry])=>header.toggleAttribute('data-past-campaign',entry.boundingClientRect.bottom<=80),{rootMargin:'-80px 0px 0px 0px'}).observe(campaignMark);
 menu.querySelector('[data-information-close]').addEventListener('click',()=>{menu.open=false;menu.querySelector('summary').focus({preventScroll:true});});
 menu.addEventListener('toggle',()=>{document.querySelector('main')?.toggleAttribute('inert',menu.open);document.querySelector('.commerce-footer')?.toggleAttribute('inert',menu.open);document.documentElement.style.overflow=menu.open?'hidden':'';header.querySelector('.commerce-header__tools')?.toggleAttribute('inert',menu.open);header.querySelector('.commerce-categories')?.toggleAttribute('inert',menu.open);});
 menu.addEventListener('keydown',event=>{if(!menu.open||event.composedPath().some(node=>node.localName==='shopify-account'))return;if(event.key==='Escape'){menu.open=false;menu.querySelector('summary').focus();}if(event.key==='Tab'){const items=[...menu.querySelectorAll('summary,button,a[href],shopify-account:defined')].filter(el=>el.getClientRects().length),first=items[0],last=items.at(-1);if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}}});
}
document.addEventListener('keydown',event=>{if(event.key==='Escape'){const panel=document.querySelector('.commerce-localization[open]');if(panel){panel.open=false;panel.querySelector('summary').focus();}}});
setupCommerceNavigation();document.addEventListener('shopify:section:load',setupCommerceNavigation);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cookie-preferences"] && !Shopify.designMode) return;
  try {
    (()=>{
    const dialog=document.getElementById('CookiePreferences');
    if(!dialog)return;
    const form=dialog.querySelector('form');
    const error=dialog.querySelector('[data-cookie-error]');
    let loading,trigger;
    function loadPrivacy(){
      if(window.Shopify?.customerPrivacy)return Promise.resolve(window.Shopify.customerPrivacy);
      if(!loading)loading=new Promise((resolve,reject)=>{
        if(!window.Shopify?.loadFeatures){reject(new Error('Privacy API unavailable'));return;}
        window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],failure=>{
          if(failure)reject(failure);else resolve(window.Shopify.customerPrivacy);
        });
      }).catch(failure=>{loading=null;throw failure;});
      return loading;
    }
    function setBusy(busy){form.querySelectorAll('button').forEach(button=>button.disabled=busy);}
    dialog.querySelector('[data-cookie-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>event.stopPropagation());
    dialog.addEventListener('keydown',event=>event.stopPropagation());
    dialog.addEventListener('close',()=>trigger?.focus({preventScroll:true}));
    document.addEventListener('click',async event=>{
      const link=event.target.closest('a[href="#shopifyReshowConsentBanner"]');
      if(!link)return;
      // Normal storefronts retain Shopify's original banner and click handler.
      let features;
      try{features=JSON.parse(document.getElementById('shopify-features')?.textContent||'{}');}catch{}
      if(features?.accessToken)return;
      event.preventDefault();event.stopImmediatePropagation();
      trigger=link;error.hidden=true;setBusy(true);if(!dialog.open)dialog.showModal();
      try{
        const privacy=await loadPrivacy(),consent=privacy.currentVisitorConsent();
        for(const name of ['preferences','analytics','marketing'])form.elements[name].checked=consent[name]==='yes';
        setBusy(false);
      }catch{error.hidden=false;setBusy(false);}
    },true);
    async function save(choice){
      setBusy(true);error.hidden=true;
      try{
        const privacy=await loadPrivacy();
        const consent=Object.fromEntries(['preferences','analytics','marketing'].map(name=>[name,choice?choice==='accept':form.elements[name].checked]));
        await new Promise((resolve,reject)=>privacy.setTrackingConsent(consent,result=>result?.error?reject(result.error):resolve()));
        dialog.close();
      }catch{error.hidden=false;}finally{setBusy(false);}
    }
    form.addEventListener('submit',event=>{event.preventDefault();save();});
    form.querySelectorAll('[data-cookie-choice]').forEach(button=>button.addEventListener('click',()=>save(button.dataset.cookieChoice)));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ft-countdown')) {
    customElements.define('ft-countdown', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.digits = this.querySelector('.countdown__digits');
        this.target = Number(this.dataset.release) * 1000;
        if (!this.dataset.release || !Number.isFinite(this.target) || this.target <= 0) {
          if (this.digits) this.digits.hidden = true;
          return;
        }
        try {
          const date = new Date(this.target);
          this.querySelector('time').textContent = new Intl.DateTimeFormat(this.dataset.locale || 'en', { dateStyle: 'long', timeStyle: 'short', timeZone: this.dataset.timezone }).format(date);
          const zone = this.querySelector('[data-zone]');
          zone.textContent = this.dataset.timezone; zone.hidden = false;
        } catch {
          this.digits.hidden = true;
          this.querySelector('.countdown__intro').hidden = true;
          return;
        }
        this.tick();
        document.addEventListener('visibilitychange', () => { clearTimeout(this.timer); if (!document.hidden) this.tick(); }, { signal: this.abort.signal });
      }
      tick() {
        clearTimeout(this.timer);
        const remaining = Math.max(0, Math.ceil((this.target - Date.now()) / 1000));
        if (remaining === 0) {
          this.digits.hidden = true;
          this.querySelector('.countdown__intro').hidden = true;
          const expired = this.querySelector('[data-expired]');
          expired.hidden = false;
          if (!this.expired) { this.querySelector('[data-announcement]').textContent = expired.textContent; this.expired = true; }
          if (this.dataset.autoLive && !window.Shopify?.designMode) {
            const key = 'ft-release-' + this.dataset.release;
            try {
              if (!sessionStorage.getItem(key)) {
                sessionStorage.setItem(key, '1');
                window.location.replace(this.dataset.autoLive);
              }
            } catch { /* A refresh still resolves the server-rendered state when storage is unavailable. */ }
          }
          return;
        }
        const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
        ['days','hours','minutes','seconds'].forEach((unit, i) => { this.querySelector('[data-' + unit + ']').textContent = String(values[i]).padStart(2, '0'); });
        this.querySelector('[data-days]').toggleAttribute('data-long', values[0] > 999);
        this.digits.hidden = this.hasAttribute('data-no-digits');
        if (!document.hidden) this.timer = setTimeout(() => this.tick(), 1000 - (Date.now() % 1000));
      }
      disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["information-style"] && !Shopify.designMode) return;
  try {
    function arrangePrivacyActions(){
    const dialog=document.getElementById('shopify-pc__prefs__dialog');
    if(!dialog||dialog.dataset.actionsArranged)return;
    const actions=dialog.querySelector('.shopify-pc__prefs__header-actions');
    const buttons=['decline','save','accept'].map(name=>dialog.querySelector('#shopify-pc__prefs__header-'+name));
    if(!actions||buttons.some(button=>!button))return;
    dialog.dataset.actionsArranged='true';
    // Move the original controls, retaining Shopify's click handlers and consent state.
    actions.append(...buttons);dialog.append(actions);
    // Shopify caches the old focus order; follow the new DOM order for Tab only.
    dialog.addEventListener('keydown',event=>{
      if(event.key!=='Tab')return;
      const items=[...dialog.querySelectorAll('button,a[href],input:not([tabindex="-1"]),select,textarea,[tabindex="0"]')].filter(item=>!item.disabled&&item.getClientRects().length);
      if(!items.length)return;
      event.preventDefault();event.stopImmediatePropagation();
      const index=items.indexOf(document.activeElement);
      items[(index+(event.shiftKey?-1:1)+items.length)%items.length].focus();
    },true);
  }
  arrangePrivacyActions();
  new MutationObserver(arrangePrivacyActions).observe(document.body,{childList:true,subtree:true});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["meta-tags"] && !Shopify.designMode) return;
  try {
    const favicon = document.querySelector('[data-foreverteen-favicon]');
  if (favicon) {
    const appearance = window.matchMedia('(prefers-color-scheme: dark)');
    const updateFavicon = () => { favicon.href = appearance.matches ? favicon.dataset.dark : favicon.dataset.light; };
    updateFavicon();
    appearance.addEventListener('change', updateFavicon);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-controller"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ft-product')) customElements.define('ft-product', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.addEventListener('click', event => { const link = event.target.closest('[data-option-link]'); if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return; event.preventDefault(); this.select(link); }, {signal:this.abort.signal});
      this.addEventListener('submit', event => { if (!event.target.matches('.piece-form')) return; event.preventDefault(); this.add(event.target); }, {signal:this.abort.signal});
      this.addEventListener('change', event => { if (event.target.name === 'selling_plan') this.plans(); }, {signal:this.abort.signal});
      this.plans();
      this.observeGalleryEnd();
    }
    observeGalleryEnd() {
      this.galleryObserver?.disconnect();
      const lastMedia = this.querySelector('.piece-gallery .piece-media:last-child');
      this.style.removeProperty('--piece-final-media-height');
      if (!lastMedia) return;
      const sync = () => this.style.setProperty('--piece-final-media-height', lastMedia.getBoundingClientRect().height + 'px');
      this.galleryObserver = new ResizeObserver(sync);
      this.galleryObserver.observe(lastMedia);
      sync();
    }
    plans() { const id = this.querySelector('[name=selling_plan]')?.value; this.querySelectorAll('[data-plan-description]').forEach(el => el.hidden = el.dataset.planDescription !== id); const price=this.querySelector('[data-price]'); if(price) price.textContent=this.querySelector('[name=selling_plan] option:checked')?.dataset.price || price.dataset.basePrice; const unit=this.querySelector('[data-base-unit-price]'); if(unit) unit.hidden=Boolean(id); }
    async select(link) {
      if (this.busy) return;
      this.pending?.abort(); const controller = new AbortController(); this.pending = controller;
      const url = new URL(link.href); url.searchParams.set('section_id', this.dataset.section);
      this.setAttribute('aria-busy','true'); const action = this.querySelector('[name=add]'); if (action) action.disabled = true;
      try {
        const response = await fetch(url, {cache:'no-store', signal:controller.signal}); if (!response.ok) throw new Error();
        const doc = new DOMParser().parseFromString(await response.text(),'text/html'); const next = doc.querySelector('ft-product'); if (!next) throw new Error();
        const id = link.dataset.optionId; const scroll = window.scrollY;
        this.innerHTML = next.innerHTML; this.dataset.url = next.dataset.url; this.dataset.state = next.dataset.state; this.dataset.dropId = next.dataset.dropId || '';
        if (this.closest('dialog.quick-add')) this.querySelector('.piece-gallery')?.remove();
        this.plans(); this.observeGalleryEnd();
        url.searchParams.delete('section_id');
        if (!this.closest('dialog.quick-add')) history.replaceState({},'',url);
        (this.querySelector('[data-option-id="'+CSS.escape(id)+'"]') || this.querySelector('[data-purchase-state]'))?.focus({preventScroll:true});
        if (!this.closest('dialog.quick-add')) window.scrollTo({top:scroll,behavior:'instant'});
      } catch(error) { if (error.name !== 'AbortError') window.location.assign(link.href); }
      finally { if (this.pending === controller) this.removeAttribute('aria-busy'); }
    }
    async add(form) {
      if (this.busy || this.hasAttribute('aria-busy') || !form.reportValidity()) return;
      const button = form.querySelector('[name=add]'); if (button.disabled) return;
      this.busy = true; button.disabled = true;
      const error = form.querySelector('[data-product-error]'), status = form.querySelector('[data-product-status]'); error.textContent = ''; status.textContent = this.dataset.loading;
      let feedback = this.dataset.error;
      try {
        // Re-render the selected variant before posting: an open tab is not a stock or lifecycle reservation.
        const selected = form.querySelector('[name=id]')?.value;
        const url = new URL(this.dataset.url, location.origin);
        url.searchParams.set('variant', selected); url.searchParams.set('section_id', this.dataset.section);
        const fresh = await fetch(url, {cache:'no-store', signal:this.abort.signal});
        if (!fresh.ok) throw new Error(this.dataset.error);
        const next = new DOMParser().parseFromString(await fresh.text(),'text/html').querySelector('ft-product');
        if (!next) throw new Error(this.dataset.error);
        const freshForm = next.querySelector('.piece-form');
        const freshButton = freshForm?.querySelector('[name=add]');
        const quantity = form.querySelector('[name=quantity]').value;
        const plan = form.querySelector('[name=selling_plan]')?.value || '';
        const freshPlan = freshForm?.querySelector('[name=selling_plan]');
        const planValid = !plan ? !freshPlan?.required : [...(freshPlan?.options || [])].some(option => option.value === plan);
        if (!freshButton || freshButton.disabled || next.dataset.state !== this.dataset.state || next.dataset.dropId !== this.dataset.dropId || freshForm.querySelector('[name=id]')?.value !== selected || !planValid) {
          this.innerHTML = next.innerHTML; this.dataset.state = next.dataset.state; this.dataset.dropId = next.dataset.dropId || '';
          if (this.closest('dialog.quick-add')) this.querySelector('.piece-gallery')?.remove();
          this.plans(); this.observeGalleryEnd();
          const notice = this.querySelector('[data-purchase-state], [data-product-error]');
          if (notice) { if (!notice.hasAttribute('data-purchase-state')) notice.textContent = this.dataset.changed; notice.focus({preventScroll:true}); }
          return;
        }
        const freshQuantity = freshForm.querySelector('[name=quantity]'); freshQuantity.value = quantity;
        if (!freshQuantity.checkValidity()) { feedback = this.dataset.changed; throw new Error(); }
        const payload = new FormData(freshForm);
        payload.set('quantity', quantity); if (plan) payload.set('selling_plan', plan);
        const response = await fetch(this.dataset.add,{method:'POST',body:payload,headers:{Accept:'application/json'},signal:this.abort.signal});
        const data = await response.json(); if (!response.ok) { feedback = typeof data.description === 'string' ? data.description : this.dataset.error; throw new Error(); }
        window.location.assign(this.dataset.cart);
      } catch { if (this.isConnected) { error.textContent = feedback; error.focus({preventScroll:true}); button.disabled=false; status.textContent=''; } }
      finally { this.busy=false; }
    }
    disconnectedCallback() { this.abort?.abort(); this.pending?.abort(); this.galleryObserver?.disconnect(); }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ft-quick-add')) customElements.define('ft-quick-add', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.trigger = this.querySelector('.quick-add__trigger');
      this.dialog = this.querySelector('dialog');
      this.body = this.querySelector('.quick-add__body');
      this.status = this.querySelector('.quick-add__status');
      this.loadingText = this.status.textContent;
      this.trigger.setAttribute('aria-haspopup', 'dialog');
      const options = {signal:this.events.signal};
      this.trigger.addEventListener('keydown', event => { if (event.key === 'Escape') this.trigger.setAttribute('data-hint-dismissed',''); }, options);
      this.trigger.addEventListener('mouseleave', () => this.trigger.removeAttribute('data-hint-dismissed'), options);
      this.trigger.addEventListener('blur', () => this.trigger.removeAttribute('data-hint-dismissed'), options);
      this.trigger.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); this.trigger.setAttribute('data-hint-dismissed',''); this.open();
      }, options);
      this.querySelector('.quick-add__close').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.request?.abort(); this.body.replaceChildren(); this.trigger.focus({preventScroll:true});
      }, options);
    }
    async open() {
      this.request?.abort(); const request = new AbortController(); this.request = request;
      this.body.replaceChildren(); this.status.textContent = this.loadingText; this.querySelector('.quick-add__details').hidden = false; this.dialog.showModal();
      try {
        const response = await fetch(this.trigger.href, {cache:'no-store', signal:request.signal});
        if (!response.ok) throw new Error();
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const product = document.querySelector('ft-product');
        if (!product) throw new Error();
        // Keep native variant, selling-plan, quantity and preorder inputs together.
        product.querySelectorAll('script').forEach(script => script.remove());
        product.querySelector('.piece-gallery')?.remove();
        this.body.append(product); this.status.textContent = '';
        this.querySelector('.quick-add__details').hidden = product.dataset.state === 'PRE_DROP';
      } catch (error) {
        if (error.name !== 'AbortError') this.status.textContent = this.dataset.error;
      }
    }
    disconnectedCallback() { this.events?.abort(); this.request?.abort(); }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["signup-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ft-klaviyo-signup')) customElements.define('ft-klaviyo-signup', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const form = this.querySelector('form');
      const button = form.querySelector('button[type=submit]');
      const email = form.querySelector('input[type=email]');
      const consent = form.querySelector('input[type=checkbox]');
      const error = form.querySelector('[data-client-error]');
      const status = form.querySelector('[data-signup-status]');
      const success = form.querySelector('[data-signup-success]');
      const label = button.textContent;
      button.disabled = button.dataset.configured !== 'true';
      form.addEventListener('input', event => {
        event.target.removeAttribute('aria-invalid');
        error.hidden = true;
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        event.stopPropagation();
        if (this.pending || button.dataset.configured !== 'true' || this.completed) return;
        email.value = email.value.trim();
        const invalid = !email.validity.valid ? email : !consent.checked ? consent : null;
        error.hidden = true;
        if (invalid) {
          error.textContent = invalid === email ? this.dataset.emailError : this.dataset.consentError;
          error.hidden = false;
          invalid.setAttribute('aria-invalid', 'true');
          invalid.focus();
          return;
        }
        this.pending = true;
        button.disabled = true;
        button.textContent = this.dataset.loading;
        form.setAttribute('aria-busy', 'true');
        status.textContent = this.dataset.loading;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);
        try {
          const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(this.dataset.siteId), {
            method: 'POST', credentials: 'omit', signal: controller.signal,
            headers: {'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2026-07-15'},
            body: JSON.stringify({data: {type: 'subscription', attributes: {
              custom_source: this.dataset.source,
              profile: {data: {type: 'profile', attributes: {email: email.value, properties: {foreverteen_drop: this.dataset.drop}, subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}}}}}
            }, relationships: {list: {data: {type: 'list', id: this.dataset.listId}}}}})
          });
          if (response.status !== 202) {
            error.textContent = response.status === 429 ? this.dataset.rateError : this.dataset.requestError;
            error.hidden = false;
            error.focus();
            return;
          }
          this.completed = true;
          form.querySelector('[data-signup-fields]').hidden = true;
          success.hidden = false;
          success.setAttribute('data-form-success', '');
          status.textContent = success.textContent;
          success.focus();
        } catch {
          error.textContent = this.dataset.requestError;
          error.hidden = false;
          error.focus();
        } finally {
          clearTimeout(timeout);
          this.pending = false;
          form.removeAttribute('aria-busy');
          button.disabled = this.completed;
          button.textContent = label;
          if (!this.completed) status.textContent = '';
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-access"] && !Shopify.designMode) return;
  try {
    function setupStorePassword(root = document) {
    root.querySelectorAll('.store-access').forEach(panel => {
      const form = panel.querySelector('form.store-password-form');
      if (!form || form.dataset.feedbackReady) return;
      form.dataset.feedbackReady = 'true';
      const button = form.querySelector('button[type=submit]');
      const status = form.querySelector('[data-password-status]');
      const label = button.textContent;
      const reset = () => { button.disabled = false; button.textContent = label; status.textContent = ''; form.removeAttribute('aria-busy'); };
      form.addEventListener('submit', () => {
        button.disabled = true;
        button.textContent = panel.dataset.passwordChecking;
        status.textContent = panel.dataset.passwordChecking;
        form.setAttribute('aria-busy', 'true');
      });
      window.addEventListener('pageshow', reset);
    });
  }
  setupStorePassword();
  document.addEventListener('shopify:section:load', event => setupStorePassword(event.target));
  } catch(e) { console.error(e); }
})();

})();
